import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class VersionsService {
  versionsUrl: string = environment.versions;

  constructor(private httpClient: HttpClient) {}

  getDeviceVersions(
    query: DeviceVersionsQuery,
  ): Promise<DeviceVersionsResponse> {
    return this.httpClient
      .post<DeviceVersionsResponse>(`${this.versionsUrl}/deviceversions`, query)
      .toPromise();
  }

  getDeviceVersion(serialNumber: string): Promise<DeviceVersion> {
    return this.httpClient
      .get<DeviceVersion>(`${this.versionsUrl}/deviceversions/${serialNumber}`)
      .toPromise();
  }

  getAppVersions(query: AppVersionsQuery): Promise<AppVersionsResponse> {
    return this.httpClient
      .post<AppVersionsResponse>(
        `${this.versionsUrl}/deviceversions/apps`,
        query,
      )
      .toPromise();
  }
}

export interface AppVersion {
  serialNumber: string;
  name: string;
  versions: string;
  status: string;
  expectedVersion?: string;
  expectedFirmwareName?: string;
  cohort?: string;
  releaseId?: string;
  lastVersionsDate?: Date;
  installDate?: Date;
}

export interface DeviceVersion {
  serialNumber: string;
  firmware: Firmware;
  moduleVersions?: ModuleVersion[];
  groupPath?: string[];
  platform?: string;
  groupId?: string;
  hardwarePlatform?: string;
}

export interface ModuleVersion {
  name?: string;
  expectedVersion?: ExpectedVersion;
  versionOnDevice?: string;
  status?: string;
}

export interface DeviceModuleVersion extends ModuleVersion {
  serialNumber: string;
}

export interface ExpectedVersion {
  version?: string;
  releaseId?: string;
  releaseName?: string;
  phase?: string;
  cohortMembershp?: string;
  deploymentDate?: Date;
  releasePriority?: number;
  configurationHash?: string;
}

export interface DeviceVersionsQuery {
  size?: number;
  serialNumbers?: string[];
  groupIds?: string[];
  modules?: { name: string; version: string; status?: string }[];
  releasesAndCohorts?: string[];
  searchAfter?: SearchAfterSortvalues;
  usePagination?: boolean;
  returnCsv?: boolean;
}

export interface AppVersionsQuery extends DeviceVersionsQuery {
  returnAllModules?: boolean;
}

interface DeviceVersionsResponse {
  deviceVersions: DeviceVersion[];
  searchAfter?: SearchAfterSortvalues;
  totalCount: number;
}

export interface AppVersionsResponse {
  appVersions: AppVersion[];
  searchAfter?: SearchAfterSortvalues;
  totalCount: number;
}

export interface SearchAfterSortvalues {
  hasModuleVersions: boolean;
  hasSerialNumbers: boolean;
}

export interface Firmware {
  versionOnDevice: FirmwareVersion;
  expectedVersion: FirmwareVersion;
  releaseId?: string; // Guid in TypeScript is typically represented as a string
  releaseName?: string;
  phase?: string;
  cohortMembership?: string;
  deploymentDate?: Date;
  releasePriority?: number;
}

export interface FirmwareVersion {
  build: string;
  name: string;
  version: string;
  firmwareId?: string;
}
